class OrpsStickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.mainForm = document.getElementById(this.dataset.mainFormId);
    this.mainButton = this.mainForm?.querySelector('[name="add"]');
    this.mainVariantInput = this.mainForm?.querySelector('input[name="id"]');
    this.stickyVariantInput = this.querySelector('input[name="id"]');
    this.stickyButton = this.querySelector('[name="add"]');
    this.stickyButtonText = this.stickyButton?.querySelector('span');
    this.priceTarget = this.querySelector('[data-orps-sticky-price]');

    if (!this.mainForm || !this.stickyVariantInput || !this.stickyButton) return;

    this.syncState = this.syncState.bind(this);
    this.mainForm.addEventListener('change', this.syncState);

    this.formObserver = new MutationObserver(this.syncState);
    this.formObserver.observe(this.mainForm, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    this.visibilityObserver = new IntersectionObserver(
      ([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting),
      { rootMargin: '0px 0px -72px 0px', threshold: 0 }
    );
    this.visibilityObserver.observe(this.mainForm);

    this.syncState();
  }

  disconnectedCallback() {
    this.mainForm?.removeEventListener('change', this.syncState);
    this.formObserver?.disconnect();
    this.visibilityObserver?.disconnect();
  }

  syncState() {
    this.mainButton = this.mainForm?.querySelector('[name="add"]');
    this.mainVariantInput = this.mainForm?.querySelector('input[name="id"]');

    if (this.mainVariantInput) {
      this.stickyVariantInput.value = this.mainVariantInput.value;
      this.stickyVariantInput.disabled = this.mainVariantInput.disabled;
    }

    const disabled = !this.mainButton || this.mainButton.disabled || !this.stickyVariantInput.value;
    this.stickyButton.disabled = disabled;

    if (this.mainButton && this.stickyButtonText) {
      const label = this.mainButton.querySelector('span')?.textContent?.trim();
      if (label) this.stickyButtonText.textContent = label;
    }

    const mainPrice = document.querySelector(this.dataset.priceSelector);
    if (mainPrice && this.priceTarget) this.priceTarget.innerHTML = mainPrice.innerHTML;
  }
}

if (!customElements.get('orps-sticky-add-to-cart')) {
  customElements.define('orps-sticky-add-to-cart', OrpsStickyAddToCart);
}
